import React, { useContext, useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import assetContext from "../../context/AssetsContext/AssetContext";
import { IMAGE_PATH } from "../../constant";
import Particles from "./Particles";
import { Sparkles } from "./Sparkles";
import { useNavigate } from "react-router-dom";

const ImageSlider1 = () => {
  const [assetsfeaturedx, setAssetsfeaturedx] = useState([]);
  const context = useContext(assetContext);
  const { assetsfeatured, getAssetsFeatured } = context;
  const navigate = useNavigate();

  useEffect(() => {
    getAssetsFeatured({
      page: 1,
    });
  }, []);

  useEffect(() => {
    setAssetsfeaturedx(assetsfeatured);
  }, [assetsfeatured]);

  const settings = {
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    nextArrow: <div className="slick-next slick-arrow" />,
    prevArrow: <div className="slick-prev slick-arrow" />,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      { breakpoint: 768, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ],
  };

  const HandleClick = (slug) => {
    window.open(`/property/${slug}`, "_blank");
    localStorage.setItem("projectData", JSON.stringify(assetsfeaturedx));
  };
  const handleDataReceived = async (city) => {
    const queryParams = new URLSearchParams({
      page: 1,
      property_type: [],
      property_status: [],
      city: [city],
      property_builder: [],
      bedroom: [],
      property_price: 20,
      bath_rooms: [],
      balconies: [],
      door_facing: [],
      furnishing_status: [],
      parking: [],
      property_name: "",
    }).toString();

    navigate(`/properties?${queryParams}`);
  };
  return (
    <div className="py-16">
      <div className="flex flex-col items-center justify-around px-4 gap-10 md:gap-16">
        <div className="flex-1 w-full max-w-7xl mx-auto text-center">
          <h2
            style={{
              fontFamily: "Playfair Display, sans-serif",
            }}
            className="text-3xl sm:text-5xl font-bold text-gray-700 leading-tight"
          >
            Find the Space Where You Truly Belong
          </h2>
          <p
            style={{
              fontFamily: "Poppins, sans-serif",
            }}
            className="mt-4 text-base sm:text-lg text-gray-500 max-w-xl mx-auto"
          >
            Explore our curated selection of premium properties. From luxury
            villas to modern apartments, we have something for everyone.
          </p>
          <div className="flex flex-row justify-center space-x-4">
           

            <button onClick={()=> handleDataReceived("Bengaluru")} className="mt-4 px-6 py-3 bg-gradient-to-r from-[#9379B8] to-[#6B5B95] text-white font-semibold rounded-lg shadow-lg transition-all duration-300 ease-in-out hover:animate-bounce-sm text-sm sm:text-base">
              Bengaluru
            </button>
            <button onClick={()=> handleDataReceived("Bhubaneswar")} className="mt-4 px-6 py-3 bg-gradient-to-r from-[#9379B8] to-[#6B5B95] text-white font-semibold rounded-lg shadow-lg transition-all duration-300 ease-in-out hover:animate-bounce-sm text-sm sm:text-base">
              Bhubaneswar
            </button>

            <style jsx>{`
              @keyframes shine {
                0% {
                  transform: translateX(-100%);
                }
                100% {
                  transform: translateX(100%);
                }
              }
              .animate-shine {
                animation: shine 1.2s ease-in-out infinite;
              }

              @keyframes bounce-sm {
                0%,
                100% {
                  transform: translateY(0);
                }
                50% {
                  transform: translateY(-6px);
                }
              }
              .hover\\:animate-bounce-sm:hover {
                animation: bounce-sm 0.4s ease-in-out;
              }
            `}</style>
          </div>

          <div className="mt-10 w-full">
            {assetsfeaturedx.length > 0 && (
              <Slider {...settings} className="relative">
                {assetsfeaturedx.map((project, index) => (
                  <div key={index} className="px-2 sm:px-4">
                    <div className="relative bg-[#1d1916] p-4 sm:p-6 rounded-2xl shadow-lg h-[420px] flex flex-col items-center text-center justify-between transition-transform hover:scale-105 duration-300 overflow-hidden">
                      <Sparkles
                        density={1200}
                        className="absolute inset-x-0 bottom-0 h-full w-full [mask-image:radial-gradient(50%_50%,white,transparent_85%)]"
                      />
                      <div className="relative z-10 flex flex-col items-center justify-between h-full">
                        <img
                          src={`${IMAGE_PATH}${project.cover_image.fieldname}/${project.cover_image.filename}`}
                          alt={project.property_name}
                          className="h-28 w-28 sm:h-32 sm:w-32 rounded-full object-cover border-4 bg-gray-700 border-blue-300 shadow-md"
                        />

                        <div className="mt-4">
                          <h3 className="text-lg sm:text-2xl font-semibold text-gray-100">
                            {project.property_name}
                          </h3>
                          <p className="text-xs sm:text-sm text-gray-200 mt-1">
                            {project.location}, {project.city}
                          </p>
                          <p className="mt-2 text-xs sm:text-sm text-gray-200 px-2">
                            {project.property_type} -{" "}
                            {project.property_dimension} sq.ft
                          </p>
                          <h4 className="text-gray-300 font-bold text-sm sm:text-lg mt-2">
                            ₹{project.property_price} Cr
                          </h4>
                        </div>

                        <button
                          onClick={() => HandleClick(project.slug)}
                          className="relative mt-4 px-6 py-2 bg-gradient-to-r from-[#9379B8] to-[#6B5B95] text-white font-semibold rounded-lg shadow-lg overflow-hidden group text-sm sm:text-base"
                        >
                          <span className="absolute inset-0 bg-gradient-to-r from-transparent via-white/40 to-transparent opacity-0 group-hover:opacity-100 animate-shine"></span>
                          <span className="relative z-10">Check Details</span>
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageSlider1;
